import { render, staticRenderFns } from "./GalleryFile.vue?vue&type=template&id=52e6a06c&scoped=true"
import script from "./GalleryFile.vue?vue&type=script&lang=ts"
export * from "./GalleryFile.vue?vue&type=script&lang=ts"
import style0 from "./GalleryFile.vue?vue&type=style&index=0&id=52e6a06c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e6a06c",
  null
  
)

export default component.exports